import { HashedSignupData } from '../../Views/Blocks/SignupBlock/classes/HashedSignupData';

export type GoogleEnhancedConversionsDataLayerEventProps = {
  event: string;
  output: string;
  business_size?: number;
  enhancedConversionUserData: HashedSignupData;
};

export class GoogleEnhancedConversionsDataLayerEvent {
  event: string;
  value: string;
  output: string;
  business_size?: number;
  enhancedConversionUserData: {
    sha256_email_address: string;
    sha256_phone_number: string;
  };

  constructor(props: GoogleEnhancedConversionsDataLayerEventProps) {
    this.event = props.event;
    this.value = props.event;
    this.output = props.output;
    this.business_size = props.business_size;
    this.enhancedConversionUserData = {
      sha256_email_address: props.enhancedConversionUserData.email.value,
      sha256_phone_number: props.enhancedConversionUserData.phoneNumber.value,
    };
  }
}
